import { render, staticRenderFns } from "./choose-category.vue?vue&type=template&id=74901093"
import script from "./choose-category.vue?vue&type=script&lang=js"
export * from "./choose-category.vue?vue&type=script&lang=js"
import style0 from "./choose-category.vue?vue&type=style&index=0&id=74901093&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports